// mui
import { Box, Grid } from '@mui/material';

// ui
import { ChipStatus, ChipStatusProps } from '../ChipStatus/ChipStatus';
import { ChipTraceability, ChipTraceabilityProps } from '../ChipTraceability/ChipTraceability';

// props
export interface ChipStatusTraceabilityProps {
	ChipStatusProps?: ChipStatusProps;
	ChipTraceabilityProps?: ChipTraceabilityProps;
}

export const ChipStatusTraceability = ({
	ChipStatusProps,
	ChipTraceabilityProps,
}: ChipStatusTraceabilityProps) => {
	return (
		<Box>
			<Grid container direction="column" spacing={1}>
				<Grid item>
					<ChipTraceability {...ChipTraceabilityProps} />
				</Grid>
				<Grid item>
					<ChipStatus {...ChipStatusProps} />
				</Grid>
			</Grid>
		</Box>
	);
};
